const getDoesDataAttrShowGender = () =>
  ["men", "women"].includes(document.documentElement.dataset.gender);

const getDoesFloorCookieShowGender = () => {
  const floor = document.cookie.match(/(^| )floor=([^;]+)/)?.[2];
  return floor && ["1000", "1001"].includes(floor);
};

// Consider this alongside Large Navigation component CSS:
// src/template/components/Navigation/LargeNavigation/index.css
document.documentElement.setAttribute(
  "data-show-nav",
  getDoesDataAttrShowGender() || getDoesFloorCookieShowGender()
    ? "true"
    : "false"
);
